import { styled } from '@mui/system'
import { DefaultShadow } from 'components/container'
import { TEST_IDS } from 'test-ids'

export const ContentWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  position: 'relative',
})

export const GridWrapper = styled('div')({
  display: 'grid',
  gridTemplateColumns: '250px 1fr',
  gridTemplateRows: '1fr',
  height: '100%',
  margin: 0,
})

export const SplitGridWrapper = styled(GridWrapper)({
  gridTemplateColumns: '1fr 1fr',
})

const StyledSidePanel = styled(DefaultShadow)({
  position: 'absolute',
  width: '250px',
  margin: 0,
  left: '0px',
  top: 0,
  bottom: 0,
})

const StyledContent = styled('div')({
  margin: 0,
  left: '250px',
  position: 'absolute',
  top: 0,
  bottom: 0,
  width: 'calc(100% - 250px)',
})

export const SidePanel = ({ children }) => {
  return (
    <StyledSidePanel id={TEST_IDS.sidePanel} data-testid={TEST_IDS.sidePanel}>
      {children}
    </StyledSidePanel>
  )
}

export const PageContent = ({ children }) => {
  return (
    <StyledContent id={TEST_IDS.pageContent} data-testid={TEST_IDS.pageContent}>
      {children}
    </StyledContent>
  )
}
